import React from "react";
import { Button } from "../ui/button";
import { Plus } from "lucide-react";

interface WorkoutActionsBarProps {
  exerciseCount: number;
  onAddExercise: () => void;
}

export const WorkoutActionsBar: React.FC<WorkoutActionsBarProps> = ({ exerciseCount, onAddExercise }) => (
  <div className="p-4 border-t flex justify-between items-center bg-muted/10">
    <div className="text-sm text-muted-foreground">
      {exerciseCount} exercise{exerciseCount !== 1 ? "s" : ""}
    </div>
    <Button onClick={onAddExercise} variant="outline" size="sm">
      <Plus className="h-3 w-3 mr-2" />
      Add Exercise
    </Button>
  </div>
);
